/**
 * URL embedded in Firebase password-reset emails as continueUrl.
 * Must be http(s) — Capacitor WebViews often use capacitor://, which Firebase Auth rejects
 * ("location.protocol must be http, https or chrome-extension").
 */
const DEFAULT_PRODUCTION_ORIGIN = 'https://www.streakerbymx.com';

export function getPasswordResetContinueUrl(): string {
  const fromEnv = process.env.REACT_APP_PASSWORD_RESET_CONTINUE_ORIGIN?.trim();
  if (fromEnv && /^https?:\/\//i.test(fromEnv)) {
    return `${fromEnv.replace(/\/$/, '')}/auth`;
  }

  if (typeof window !== 'undefined') {
    const { protocol, origin } = window.location;
    if (protocol === 'http:' || protocol === 'https:') {
      return `${origin.replace(/\/$/, '')}/auth`;
    }
  }

  return `${DEFAULT_PRODUCTION_ORIGIN}/auth`;
}
